import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { useAuthState } from "../../../../../../../../Helper/Context";
import { Loading } from "../../../../../../../../Helper/Loading";
import { HeaderIllegal } from "../../../../IllegalConstructionDashboard/HeaderIllegal";
import EnchrochmentSidebar from "../../../EnchrochmentSidebar/EnchrochmentSidebar";
import ViewURL from "../Modal/ViewURL";
import { ZoneNameCommanDDL } from "../../../../../../../../Components/IllegalDDL/ZoneNameCommanDDL";
import { EmployeeCommanDDL } from "../../../../../../../../Components/IllegalDDL/EmployeeCommanDDL";
import { DesignationCommanDDL } from "../../../../../../../../Components/IllegalDDL/DesignationCommanDDL";
import { Pegination } from "../../../../../../../../Components/Pegination/Pegination";
import { EmployeeAttendanceGetTableDataAPI } from "../../../../../../../../Redux/EnchrochmentDashboardSlice/SelfAttendanceSlice/SelfAttendanceSlice";

export const PresentEmployeGrid = () => {

    const dispatch = useDispatch()
    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()

    // let YearValue = searchParams.get("YearValue")
    // let MonthValue = searchParams.get("MonthValue")
    // let ZoneValue = searchParams.get("ZoneValue");
    let DashSelect = searchParams.get("DashSelect");
    let Flag = searchParams.get("Flag");
    const ScreenNameTotal = searchParams.get('ScreenNameTotal')

    const [IsPost, setIsPost] = useState(false)

    const [IsClear, setIsClear] = useState(false)
    const [IsSearch, setIsSearch] = useState(false)

    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = useState('')
    const [showImagePopup, setshowImagePopup] = useState(false)

    const [FromDate, setFromDate] = useState(moment().format('YYYY-MM-DD'))
    const [ToDate, setToDate] = useState('')
    const [EmployeeName, setEmployeeName] = useState('')


    const [GridData, setGridData] = useState([])

    // ------------header DDL ------------

    const [YearValue, setYearValue] = useState(sessionStorage.getItem('yearId'))
    const [YearLabel, setYearLabel] = useState(sessionStorage.getItem('yearLable'))
    const [MonthValue, setMonthValue] = useState(sessionStorage.getItem('monthId'))
    const [MonthLabel, setMonthLabel] = useState(sessionStorage.getItem('monthLable'))
    const [ZoneValue, setZoneValue] = useState(sessionStorage.getItem('zoneId'))
    const [ZoneLabel, setZoneLabel] = useState(sessionStorage.getItem('ZoneLable'))

    const [isopen, setIsOpen] = useState(false);
    const toggle = () => {
        setIsOpen(!isopen);
    };

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: sessionStorage.getItem('LanguageChange')
    })

    const [ZoneNameID, setZoneNameID] = useState({
        DDL: [],
        ID: ZoneValue && ZoneValue ? ZoneValue : '0',
        Label: ZoneLabel && ZoneLabel ? ZoneLabel : "Select...",
    })

    const [DesignationNameID, setDesignationNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [EmployeeNameID, setEmployeeNameID] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setFromDate('')
        setToDate('')
        setEmployeeName('')
        setZoneNameID({
            ...ZoneNameID,
            ID: 0,
            Label: 'Select...'
        })
        setDesignationNameID({
            ...DesignationNameID,
            ID: 0,
            Label: 'Select...'
        })
        setEmployeeNameID({
            ...EmployeeNameID,
            ID: 0,
            Label: 'Select...'
        })
    }
    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ZoneNameID.ID, DesignationNameID.ID, EmployeeNameID.ID])

    useEffect(() => {
        const data = {
            M_FinancialYearID: YearValue,
            M_MonthID: MonthValue,
            FromDate: FromDate,
            ToDate: '',
            M_ZoneID: ZoneNameID.ID ? ZoneNameID.ID : ZoneValue,
            M_DesignationID: DesignationNameID.ID,
            M_EmployeeID: EmployeeNameID.ID,
            T_Encroach_SelfAttendanceID: 0,
            M_WorkTypeID: DashSelect,
            Language: Language.Label,
            M_UserID: UserID,
            FromTop: From,
            ToTop: To,
            token: token,
            Flag: "Present",
        }
        if (Language.Label != null) {
            dispatch(EmployeeAttendanceGetTableDataAPI({ data }))
        }
    }, [YearValue, MonthValue, DashSelect, From, IsClear, IsSearch, IsPost, Language.Label, FromDate, ZoneValue, ZoneNameID.ID, EmployeeNameID.ID])

    const { isLoading, tableData } = useSelector(state => state.EmployeeAttendanceGetTableData)

    return (
        <>
            {isLoading && <Loading />}
            <HeaderIllegal />
            <div className="wrapper bg-change">
                <EnchrochmentSidebar
                />
                <div className="content1 content mt-1 " style={{}}>

                    <div className="row">
                        <div className="col-12">
                            <h5 className="text-dark fw-bold ps-3 pt-3 all_heading_fontsize">{t('EncroachmentDashboard.PresentEmployee')}
                            </h5>
                        </div>
                    </div>
                    <div className="row ps-3 py-2 eic_table_styles" >

                        <div class="col-12 col-lg-3 pt-2">
                            <label for="fname" className=" pb-2">{t('EncroachmentDashboard.date')}</label><br />
                            <input
                                className="form-control"
                                id="FromDate"
                                type="date"
                                name="FromDate"
                                value={FromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <ZoneNameCommanDDL
                                ZoneNameID={ZoneNameID}
                                setZoneNameID={setZoneNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost=''
                                Language={Language}
                            />
                        </div>

                        <div class="col-12 col-lg-3 pt-2">
                            <DesignationCommanDDL
                                DesignationNameID={DesignationNameID}
                                setDesignationNameID={setDesignationNameID}
                                Flag='Insert'
                                data=''
                                IsPost=''
                                Language={Language}
                            />
                        </div>

                        <div className="col-12 col-lg-3 pt-2">
                            <EmployeeCommanDDL
                                EmployeeNameID={EmployeeNameID}
                                setEmployeeNameID={setEmployeeNameID}
                                DesignationNameID={DesignationNameID}
                                Flag='Insert'
                                ApiFlag='Master'
                                data=''
                                IsPost={IsPost}
                                Language={Language}
                            />
                        </div>

                        <div className="col-12 col-lg-12 col-md-4  mt-4 pt-4 mt-lg-2 pt-lg-2 text-end">
                            <button type="button" className="btn btn-success mx-3">Search</button>
                            <button type="button" className="btn btn-danger " onClick={handleClear}>Clear</button>
                        </div>

                        <div className="row" >
                            <div className="col-12  " >
                                <div className="table-responsive pt-3">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="w-6 text-center">{t('EncroachmentDashboard.SrNo')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.date')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ZoneName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.DesignationName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.EmployeeName')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.ShiftTime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.Intime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OutTime')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.TotalHrs')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.INPhoto')}</th>
                                                <th className="text-center">{t('EncroachmentDashboard.OutPhoto')}</th>

                                            </tr>

                                        </thead>
                                        <tbody>
                                            {
                                                tableData && tableData?.length > 0 ? tableData?.map((i, j) => {
                                                    return (
                                                        <tr>
                                                            <td className="py-1" align="center" >{i?.rowNum}</td>
                                                            <td className="nowrap">{i.attendanceDate ? moment(i.attendanceDate).format("DD-MM-YYYY") : '-'}</td>
                                                            <td className="nowrap" >{i.zoneName ? i.zoneName : '-'}</td>
                                                            <td >{i.designationName ? i.designationName : '-'}</td>
                                                            <td >{i.employeeName ? i.employeeName : '-'}</td>
                                                            <td className="nowrap" >{i.m_Indicator_ShiftName ? i.m_Indicator_ShiftName : '-'}</td>
                                                            <td className="nowrap" >{i.in_Time ? i.in_Time : '-'}</td>
                                                            <td >{i.out_Time ? i.out_Time : '-'}</td>
                                                            <td className="nowrap" >{i.totalWorkingHours ? i.totalWorkingHours : '-'}</td>

                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.in_Photo == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.in_Photo)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>

                                                                }

                                                            </td>
                                                            <td className="text-center pt-2">
                                                                {
                                                                    (i.out_Photo == null) ?
                                                                        <span>-</span>
                                                                        :
                                                                        <button className="view_button " onClick={() => handleShowImage(i.out_Photo)}>
                                                                            {/* {t('EncroachmentDashboard.View')} */}
                                                                            <i class="fa-regular fa-image"></i>
                                                                        </button>

                                                                }

                                                            </td>
                                                          
                                                        </tr>
                                                    )
                                                })
                                                    :
                                                    <tr>
                                                        <td colSpan={11}>No data found ...</td>
                                                    </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {tableData && tableData.length > 0 &&
                                    <Pegination
                                        PerPageCount={PerPageCount}
                                        TotalCount={tableData && tableData[0].totalCount}
                                        setFrom={setFrom}
                                        setTo={setTo}
                                        CurrentPage={CurrentPage}
                                        setCurrentPage={setCurrentPage}
                                        IsClear={IsClear}
                                    />
                                }
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {
                showImagePopup ?
                    <ViewURL
                        Heading={t('EncroachmentDashboard.View')}
                        setshowImagePopup={setshowImagePopup}
                        ImagePopUpData={ImagePopUpData}

                    />
                    : ''
            }

        </>
    )
}

